<rt-button
  #dropdownTrigger="rtOverlayOrigin"
  (mousedown)="placeholderSelectDropdownToggle($event)"
  [rtTooltip]="placeholderCategoryTranslationMap[category].desc"
  [rtTooltipMaxWidth]="300"
  [pressed]="placeholderSelectDropdown.open"
  variant="tertiary"
  size="small"
  rt-overlay-origin
>
  <span class="text">{{ placeholderCategoryTranslationMap[category].name }}</span>
  <rt-icon [name]="placeholderSelectDropdown.open ? 'arrow-drop-up' : 'arrow-drop-down'" />
</rt-button>

<ng-template
  #placeholderSelectDropdown="rtConnectedOverlay"
  [origin]="dropdownTrigger"
  [rtConnectedOverlayPosition]="['bottomleft']"
  (backdropClick)="placeholderSelectDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-placeholder-select-dropdown
    [placeholders]="placeholders"
    [activeTarget]="activeTarget"
    [category]="category"
    (select)="select.emit($event)"
  />
</ng-template>
